var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperAirplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1402 18C10.9809 17.9999 10.8248 17.9556 10.6893 17.872C10.5538 17.7883 10.4442 17.6686 10.3728 17.5263L7.82913 12.4366C7.76036 12.299 7.72977 12.1455 7.74057 11.9921C7.75136 11.8387 7.80314 11.691 7.8905 11.5644L11.9976 6.00104L6.43419 10.1065C6.30771 10.1937 6.16016 10.2454 6.00691 10.2562C5.85366 10.267 5.70032 10.2365 5.56287 10.1679L0.471529 7.62425C0.322561 7.54917 0.198728 7.43226 0.115207 7.28786C0.0316848 7.14346 -0.00789861 6.97782 0.00130673 6.81126C0.0105121 6.64469 0.0681064 6.48443 0.167032 6.35011C0.265958 6.21579 0.401918 6.11324 0.558253 6.05504L16.8435 0.0531032C16.9971 -0.00366252 17.1638 -0.0152014 17.3238 0.0198538C17.4837 0.0549091 17.6303 0.135089 17.7461 0.250893C17.8619 0.366697 17.9421 0.51327 17.9771 0.673246C18.0122 0.833222 18.0007 0.999894 17.9439 1.15351L11.9428 17.4396C11.8847 17.5962 11.7821 17.7325 11.6477 17.8318C11.5133 17.931 11.3528 17.9889 11.186 17.9984L11.1402 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperAirplane);
export default __webpack_public_path__ + "static/media/paper-airplane.7d47507431a8c127fb272adfc7e35d16.svg";
export { ForwardRef as ReactComponent };